import SelectedPlan        from "src/composables/SelectedPlan";
import Orders              from "src/composables/Orders";
import Plans               from "src/composables/Plans";
import AvailableDates      from "src/composables/AvailableDates";
import ServiceStartDate    from "src/composables/ServiceStartDate";
import ServiceLocation     from "src/composables/ServiceLocation";
import CustomerInformation from "src/composables/CustomerInformation";
import { Notify }          from "quasar";
import PlanFilters         from "src/composables/PlanFilters";
import Tdsps               from "src/composables/Tdsps";
import UsageFilters        from "src/composables/UsageFilters";
import { orders_api }      from "boot/axios";
import Terms               from "src/composables/Terms";
import Analytics           from "src/composables/Analytics";
import Utilities           from "src/composables/Utilities";
import ContactCenter       from "src/composables/ContactCenter";

const { selected_plan, is_Constellation } = SelectedPlan();
const { order_id, order, order_status, mark_order_as_paid, deposit_payment_error_codes, is_dirty } = Orders();
const { get_plan_by_id, search_plans, calculate_plan_for_usage, historical_usage_plan_map } = Plans();
const { all_valid, action, selected_start_date } = ServiceStartDate();
const { service_location, get_service_location_by_key, property_type, owns_property, duns_match } = ServiceLocation();
const { available_dates, get_available_dates } = AvailableDates();
const customer_info = CustomerInformation();
const { filters } = PlanFilters();

const { zip_code, clear_zip_code, get_tdsp_by_id, search_tdsps, selected_tdsp } = Tdsps();

const {
  is_live_link_usage,
  historical_usage,
  usage_type,
  usage_selected,
  custom_usage_amount,
  show_historical_usage,
  historical_usage_values,
  clear,
  show_live_link_info
} = UsageFilters();
const { available_terms, selected_terms } = Terms();
const { process_contact_center_link } = ContactCenter();

const require_selected_plan = async () => {
  if (!selected_plan.value) {
    return { path: '/' }
  }
}

const { log_event } = Analytics();

const handle_order_query_params = async (to) => {
  const {
    order_id,
    plan_id,
    first_name,
    last_name,
    email,
    phone_number,
    language,
    esiid,
    property_type: property_type_value,
    owns_property: owns_property_value,
    action: action_value,
    selected_start_date: selected_start_date_value,
    internal_visitor,
    cp_link_id,
    cp_afid,
    cp_afcid
  } = to.query;
  if (plan_id) {
    selected_plan.value = await get_plan_by_id({ plan_id })
  }
  if (first_name) {
    customer_info.first_name.value = first_name;
  }
  if (last_name) {
    customer_info.last_name.value = last_name;
  }
  if (email) {
    customer_info.email.value = email;
    customer_info.confirm_email.value = email;
  }
  if (phone_number) {
    customer_info.phone_number.value = phone_number;
  }
  if (language) {
    customer_info.spanish.value = language?.toLowerCase() === 'spanish'
  }
  if (esiid) {
    service_location.value = await get_service_location_by_key({ esiid });
    zip_code.value = service_location.value.zip_code
    if (!duns_match.value) {
      return { path: '/order/service_location', query: { cp_afcid, cp_afid } }
    }
  }
  if (property_type_value) {
    property_type.value = property_type_value
  }
  if (owns_property_value) {
    owns_property.value = owns_property_value === 'true';
  }
  if (action_value) {
    switch (action_value.toLowerCase()) {
      case 'move':
        action.value = 'Move';
        break
      case 'switch':
        action.value = 'Switch';
        break
      case 'asap':
        action.value = 'ASAP';
        break
    }
  }

  if (selected_start_date_value) {
    selected_start_date.value = selected_start_date_value
  }

  if (cp_link_id && !internal_visitor) {
    if (first_name || last_name) {
      const customer_name = [first_name, last_name].filter(Boolean).join(' ').trim()
      process_contact_center_link({ customer_name, cp_link_id })
    }
    else {
      process_contact_center_link({ cp_link_id })
    }
  }
}
const { loaded } = Utilities();
const parse_plan_filter_params = async function (to) {
  if (to.query.zip_code) {
    clear_zip_code()
    loaded.value = true;
    zip_code.value = to.query.zip_code.substr(0, 5);
  }
  if (to.query.tdsp_duns) {
    loaded.value = true;
    await get_tdsp_by_id({ tdsp_duns: to.query.tdsp_duns });
  }

  if (selected_tdsp.value) {
    await search_plans();
  }
  else if (zip_code.value) {
    await search_tdsps()
  }

  if (to.query.only_green) {
    loaded.value = true;
    filters.only_100_percent_green.selected = to.query.only_green.toLowerCase() === 'true';
  }
  if (to.query.only_no_deposit) {
    loaded.value = true;
    filters.only_no_deposit.selected = to.query.only_no_deposit.toLowerCase() === 'true';
  }
  if (to.query.only_time_of_use) {
    loaded.value = true;
    filters.only_time_of_use.selected = to.query.only_time_of_use.toLowerCase() === 'true';
  }
  if (to.query.brand_ids) {
    if (Array.isArray(to.query.brand_ids)) {
      filters.selected_brands = to.query.brand_ids;
    }
    else {
      filters.selected_brands = [to.query.brand_ids];
    }
    loaded.value = true;
  }
  if (to.query?.term) {
    if (Array.isArray(to.query.term)) {
      selected_terms.value = to.query.term.map(x => parseInt(x));
    }
    else {
      selected_terms.value = [parseInt(to.query.term)];
    }
    loaded.value = true;
  }
  if (to.query?.contract_type === 'no_contract') {
    const no_contract_term_options = available_terms.value.filter(x => x.value === 1).map(x => x.value);
    if (no_contract_term_options.length) {
      loaded.value = true;
      selected_terms.value = [no_contract_term_options[0]];
    }
  }
  else if (to.query?.contract_type === 'contract_only') {
    const contract_term_options = available_terms.value.filter(x => x.value !== 1).map(x => x.value);
    if (contract_term_options.length) {
      loaded.value = true;
      selected_terms.value = contract_term_options;
    }
  }
}

const parse_usage_query_params = async function (to) {
  const {
    clear_usage,
    is_live_link_usage: is_live_link_usage_value
  } = to.query

  if (is_live_link_usage_value && is_live_link_usage_value === 'true') {
    is_live_link_usage.value = true;
    show_live_link_info.value = false
  }

  if (clear_usage) {
    clear()
  }
  else if (to.query.historical_usage) {
    show_live_link_info.value = true
    usage_type.value = 'historical';
    if (Array.isArray(to.query.historical_usage)) {
      for (let i = 0; i < to.query.historical_usage.length; i++) {
        const value = parseInt(to.query.historical_usage[i])
        if (!isNaN(value)) {
          historical_usage.value[i].usage = parseInt(to.query.historical_usage[i])
        }
      }
    }
    else {
      historical_usage.value[0].usage = parseInt(to.query.historical_usage)
    }
  }
  else if (to.query.usage) {
    show_live_link_info.value = true
    usage_selected.value = parseInt(to.query.usage);
    usage_type.value = 'kWh'
    if (![500, 1000, 2000].includes(usage_selected.value)) {
      custom_usage_amount.value = usage_selected.value;
    }
  }
}

const check_for_order_is_dirty = () => {
  if (is_dirty.value) {
    Notify.create({
      message: `We are reloading your order to get the latest update.`,
      color: 'warning',
      textColor: 'white',
      classes: 'text-bold rounded-borders-10',
      actions: [
        { label: 'Dismiss', color: 'white' }
      ]
    })
    return { path: '/order/processing' }
  }
}

const routes = [
  {
    path: '/callback',
    component: () => import('pages/Callback.vue')
  },
  {
    path: '/',
    component: () => import('layouts/PlansLayout'),
    children: [
      {
        name: 'plan_selection',
        path: '',
        component: () => import('pages/PlanSelection'),
        beforeEnter: [parse_plan_filter_params, parse_usage_query_params, handle_order_query_params]
      }
    ],
    meta: { title: 'Plan Selection' }
  },

  {
    name: 'order_service_location',
    path: '/order/service_location',
    component: () => import('pages/order/ServiceLocation'),
    beforeEnter: [parse_usage_query_params, handle_order_query_params, require_selected_plan],
    meta: { title: 'Service Location' }
  },
  {
    name: 'order_start_date',
    path: '/order/start_date',
    component: () => import('pages/order/StartDate'),
    beforeEnter: [parse_usage_query_params, handle_order_query_params, require_selected_plan, async () => {
      if (!service_location.value || owns_property.value === null || !property_type.value) {
        return { path: '/order/service_location' }
      }
      else {
        let meter_type = 'Non-Standard';
        if (['AMSR', 'AMSM'].includes(service_location.value.tdsp_ams_indicator)) {
          meter_type = service_location.value.tdsp_ams_indicator;
        }
        available_dates.value = await get_available_dates({
          brand: selected_plan.value.product.brand.name,
          duns_number: selected_plan.value.tdsp.duns_number,
          meter_type
        })
        if (selected_start_date.value) {
          let available_dates_to_check = available_dates.value;
          if(is_Constellation.value && action.value !== 'Move') {
            available_dates_to_check = available_dates.value.slice(3);
          }
          const found = available_dates_to_check.find(x => x.date === selected_start_date.value)
          if (!found) {
            Notify.create({
              message: `Your selected start date of ${ selected_start_date.value } is no longer available`,
              caption: 'Choose another date',
              color: 'negative',
              textColor: 'white',
              classes: 'text-bold rounded-borders-10',
              actions: [
                { label: 'Dismiss', color: 'white' }
              ]
            })
            selected_start_date.value = null;
          }
        }
      }
    }],
    meta: { title: 'Start Date' }
  },
  {
    name: 'order_customer_information',
    path: '/order/customer_information',
    component: () => import('pages/order/CustomerInformation'),
    beforeEnter: [parse_usage_query_params, handle_order_query_params, require_selected_plan, async (to) => {
      const { cp_afid, cp_afcid } = to.query
      if (!service_location.value || owns_property.value === null || !property_type.value) {
        return { path: '/order/service_location', query: { cp_afid, cp_afcid } }
      }
      if (!all_valid.value) {
        return { path: '/order/start_date', query: { cp_afid, cp_afcid } }
      }

      if (selected_start_date.value) {
        let meter_type = 'Non-Standard';
        if (['AMSR', 'AMSM'].includes(service_location.value.tdsp_ams_indicator)) {
          meter_type = service_location.value.tdsp_ams_indicator;
        }
        available_dates.value = await get_available_dates({
          brand: selected_plan.value.product.brand.name,
          duns_number: selected_plan.value.tdsp.duns_number,
          meter_type
        })
        let available_dates_to_check = available_dates.value;
        if(is_Constellation.value && action.value !== 'Move') {
          available_dates_to_check = available_dates.value.slice(3);
        }
        const found = available_dates_to_check.find(x => x.date === selected_start_date.value)
        if (!found) {
          Notify.create({
            message: `Your selected start date of ${ selected_start_date.value } is no longer available`,
            caption: 'Choose another date',
            color: 'negative',
            textColor: 'white',
            classes: 'text-bold rounded-borders-10',
            actions: [
              { label: 'Dismiss', color: 'white' }
            ]
          })
          selected_start_date.value = null;
          return { path: '/order/start_date', query: { cp_afid, cp_afcid } }
        }
      }

      try {
        const params = {
          plan_id: selected_plan.value._id,
          owns_property: owns_property.value,
          property_type: property_type.value,
        };
        if (show_historical_usage.value) {
          params.usages = historical_usage_values.value;
        }
        else if (custom_usage_amount.value) {
          params.usages = custom_usage_amount.value;
        }

        const { data: alt_plan } = await orders_api.get('/api/alternative_plans', {
          params
        })
        log_event({ name: 'plan_swap_admin', plan: alt_plan });
        selected_plan.value = historical_usage_plan_map(alt_plan);
      }
      catch (err) {

      }
    }],
    meta: { title: 'Customer Information' }
  },
  {
    name: 'order_authorizations',
    path: '/order/authorizations',
    component: () => import('pages/order/Authorizations'),
    beforeEnter: [handle_order_query_params, require_selected_plan, () => {
      if (!service_location.value) {
        return { path: '/order/service_location' }
      }
      if (!all_valid.value) {
        return { path: '/order/start_date' }
      }
      if (!customer_info.customer_information_valid.value) {
        return { path: '/order/customer_information' }
      }
    }],
    meta: { title: 'Order Authorizations' }
  },
  {
    name: 'social_security_number_required',
    path: '/order/social_security_number_required',
    component: () => import('pages/order/SocialSecurityNumberRequired.vue'),
    meta: { title: 'Order SSN Required' }
  },
  {
    name: 'order_error',
    path: '/order/error',
    component: () => import('pages/order/OrderError'),
    beforeEnter: [check_for_order_is_dirty, () => {
      if (!order.value) {
        return { path: '/order/processing' }
      }
    }],
    meta: { title: 'Order Error' }
  },

  {
    name: 'order_agreements',
    path: '/order/agreements',
    component: () => import('pages/order/Agreements.vue'),
    beforeEnter: [check_for_order_is_dirty, () => {
      const allowed = ['agreements'].includes(order_status.value);
      if (allowed) {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    }],
    meta: { title: 'Order Agreements' }
  },
  {
    name: 'order_deposit_options',
    path: '/order/deposit_options',
    component: () => import('pages/order/DepositOptions'),
    beforeEnter: [check_for_order_is_dirty, () => {
      if (order?.value?.deposit_options) {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    }],
    meta: { title: 'Deposit Options' }
  },
  {
    name: 'order_review_deposit_option',
    path: '/order/review_deposit_option',
    component: () => import('pages/order/ReviewDepositOption'),
    beforeEnter: [check_for_order_is_dirty, (to) => {
      if (order_id.value && to.query.plan_id) {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    }],
    props: route => ({
      plan_id: route.query.plan_id
    }),
    meta: { title: 'Review Deposit Option' }
  },

  {
    name: 'order_deposit_payment',
    path: '/order/deposit_payment',
    component: () => import('pages/order/DepositPayment'),
    beforeEnter: [check_for_order_is_dirty, () => {
      if (deposit_payment_error_codes.includes(order_status.value)) {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    }],
    meta: { title: 'Deposit Payment' }
  },

  {
    name: 'missing_id_information',
    path: '/order/missing_id_information',
    component: () => import('pages/order/MissingIdInformation'),
    beforeEnter: [check_for_order_is_dirty, () => {
      if (order_status.value === 'missing_id_information') {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    }],
    meta: { title: 'Missing ID Information' }
  },

  {
    name: 'order_processing',
    path: '/order/processing',
    component: () => import('pages/order/Processing'),
    props: route => ({
      order_id: route.query.order_id
    }),
    meta: { title: 'Order Processing' }
  },

  {
    name: 'order_verification',
    path: '/order/verification',
    component: () => import('pages/order/Verification.vue'),
    beforeEnter: [() => {
      if (['invalid_sms_code', 'no_sms_code_submitted', 'invalid_sms_phone_number'].includes(order_status.value)) {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    }],
    props: route => ({
      order_id: route.query.order_id
    }),
    meta: { title: 'Order Verification' }
  },

  {
    name: 'order_pending',
    path: '/order/pending',
    component: () => import('pages/order/Pending'),
    beforeEnter: () => {
      if (order_status.value === 'pending') {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    },
    meta: { title: 'Order: Pending' }
  },
  {
    name: 'order_confirmation_action_required',
    path: '/order/confirmation_action_required',
    component: () => import('pages/order/ConfirmationActionRequired.vue'),
    beforeEnter: () => {
      if (order_status.value === 'confirmation_action_required') {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    },
    meta: { title: 'Order: Confirmation Action Required' }
  },
  {
    name: 'order_confirmation',
    path: '/order/confirmation',
    component: () => import('pages/order/Confirmation'),
    beforeEnter: () => {
      if (order_status.value === 'complete') {
        return true;
      }
      else {
        return { path: '/order/processing' }
      }
    },
    meta: { title: 'Order: Confirmation' }
  },

  {
    name: 'order_payment_complete',
    path: '/order/payment_complete',
    component: import('pages/order/Confirmation'),
    beforeEnter: async (to) => {
      order_id.value = to.query.order_id;
      if (order_id.value) {
        await mark_order_as_paid({ order_id: order_id.value, payload: to.query });
      }
      return { path: '/order/processing' }
    },
    meta: { title: 'Payment Complete' }
  },

  {
    path: '/tdsp_fees',
    component: () => import('pages/TdspFees')
  },

  {
    path: '/test',
    component: () => import('pages/Test')
  },

  {
    name: 'plan_summary',
    path: '/plan_summary',
    component: () => import('pages/PlanSummary'),
    beforeEnter: [
      parse_usage_query_params,
      async (to) => {
        const plan_id = to.query.plan_id;
        selected_plan.value = await get_plan_by_id({ plan_id });
        if (!selected_plan.value[`display_pricing_${ usage_selected.value }`]) {
          selected_plan.value[`display_pricing_${ usage_selected.value }`] = await calculate_plan_for_usage({
            plan_id,
            usage: usage_selected.value
          })
        }
        if (show_historical_usage.value) {
          for (const hist of historical_usage_values.value) {
            if (!selected_plan.value[`display_pricing_${ hist }`]) {
              selected_plan.value[`display_pricing_${ hist }`] = await calculate_plan_for_usage({
                plan_id,
                usage: hist
              })
            }
            selected_plan.value[`display_pricing_${ hist }`]
          }
          selected_plan.value = historical_usage_plan_map(selected_plan.value);
        }
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
